import axios from 'axios';
import { useApi } from '@dreamtree-org/twreact-ui';
import apiMap from '@api';

/**
 * App-configured wrapper around twreact-ui's useApi. Same-origin (Vite proxies
 * /api to the backend); withCredentials so the httpOnly JWT cookie is sent.
 * Returns { data, error, loading, fetchApi, fetchData }.
 */
export function useAppApi() {
  return useApi({
    apiMap,
    createRequestInstance: () => axios.create({ withCredentials: true }),
  });
}
